import Experiment from '@mc/experiments-react'
import { Trans, withI18nContext } from '@mc/i18n'
import { paths } from '@mc/paths'
import { EXPERIMENT_FLAG } from '../constants'
import { PRCNG_1079_I18N_NAMESPACE, i18nInstance } from '../i18n'

// Both branches are module-scope components so `ExperimentLoader` receives a
// stable component identity across the (frequent) re-renders of
// `getPricingSection()` and does not remount the subtree each time.

const ControlAnswer = () => (
  <Trans i18nKey='faq.pricing.answer4' ns='@mc/next'>
    <p className='mc-opacity--hinted' />
    <br />
    <p className='mc-opacity--hinted'>
      <a href={paths.helpCenter} className='mc-text--link' />
    </p>
  </Trans>
)

const VariantAnswer = withI18nContext(i18nInstance)(() => (
  <Trans i18nKey='faq.pricing.answer4' ns={PRCNG_1079_I18N_NAMESPACE}>
    <p className='mc-opacity--hinted' />
    <br />
    <p className='mc-opacity--hinted'>
      <a href={paths.helpCenter} className='mc-text--link' />
    </p>
  </Trans>
))

/**
 * "How do I cancel?" answer on the shared pre-paywall pricing FAQ.
 *
 * `default` (not `control`) so control, flag-off and any unknown future bucket
 * all fall back to the existing copy.
 *
 * `track={false}`: this node lives inside `Accordion.Item`, which only renders
 * its children once expanded, so the built-in `ExperimentTracker` would fire on
 * expand rather than on view. Exposure is fired instead by the
 * `TrackingContainer` around `<McFaq>` in `components/FAQ/FAQ.tsx`.
 */
export const CancelAnswerWrapper = () => (
  <Experiment
    name={EXPERIMENT_FLAG}
    default={ControlAnswer}
    variant_1={VariantAnswer}
    track={false}
  />
)
